import React from 'react';
import apiclient from 'lib/apiclient';
import { useHistory, useLocation } from 'react-router-dom';
import { Button } from 'reactstrap';

const Table = (props) => {
  const {
    detail,
    onNewApiKeyClickST,
    onNewApiKeyClickSTPN,
    onNewApiKeyClickCS
  } = props;

  return (
    <React.Fragment>
      <table className='table table-striped' aria-labelledby="tabelLabel">
        <tbody>
        <tr><td>ID</td><td>{detail.id}</td></tr>
        <tr><td>管理番号</td><td>{detail.managementNumber}</td></tr>
        <tr><td>顧客名</td><td>{detail.name}</td></tr>
        <tr><td>エリア</td><td>{detail.area}</td></tr>
        <tr><td>営業担当者</td><td>{detail.salesName}</td></tr>
        <tr><td>サポート担当者</td><td>{detail.supportName}</td></tr>
        <tr><td>送信元</td><td>{detail.replyAddress}</td></tr>
        <tr><td>表示名</td><td>{detail.replyDisplayName}</td></tr>
        <tr><td>トークン付きURLを使用</td><td>{detail.useToken ? '✓' : ''}</td></tr>
        <tr><td>体験版</td><td>{detail.isFreeTrial ? '✓' : ''}</td></tr>
        <tr><td>デモ</td><td>{detail.isDemo ? '✓' : ''}</td></tr>
        <tr><td>自動アップデート</td><td>{detail.autoUpgradeEnabled ? '✓' : ''}</td></tr>
        <tr><td>自動アップデート日</td><td>{detail.autoUpgradeFrom}</td></tr>
        </tbody>
      </table>
      <Button onClick={onNewApiKeyClickST}>StaffNavigator-Key追加</Button>
      <Button onClick={onNewApiKeyClickSTPN}>PlusNaviForSta-Key追加</Button>
      <Button onClick={onNewApiKeyClickCS}>CastingNavi-Key追加</Button>
      <table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr>
            <th>ApiKey</th>
            <th>種類</th>
          </tr>
        </thead>
        <tbody>
          {detail.apiKeys.map(item =>
            <tr key={item.id}>
              <td>{item.id}</td>
              <td>{item.role}</td>
            </tr>
          )}
        </tbody>
      </table>
    </React.Fragment>
  );
}

export default (props) => {
  const [data, setData] = React.useState({});
  const history = useHistory();
  const location = useLocation();

  const id = props.match && props.match.params && props.match.params.id;

  React.useEffect(() => {
    apiclient.get(`api/customer/${id}`)
      .then(response => {
        setData({ detail: response.data, loaded: true });
      });
  }, [id]);

  const handleNewApiKeyST = React.useCallback(() => {
    apiclient.post(`api/customer/${id}/apikey/StaffNavigator`)
      .then(response => {
        alert(response.data.apiKey);
      });
  }, [])

  const handleNewApiKeySTPN = React.useCallback(() => {
    apiclient.post(`api/customer/${id}/apikey/StaffNavigator?plusnavi=true`)
      .then(response => {
        alert(response.data.apiKey);
      });
  }, [])

  const handleNewApiKeyCS = React.useCallback(() => {
    apiclient.post(`api/customer/${id}/apikey/CastingNavi`)
      .then(response => {
        alert(response.data.apiKey);
      });
  }, [])


  const contents = data.loaded
    ? <Table detail={data.detail} onNewApiKeyClickST={handleNewApiKeyST} onNewApiKeyClickSTPN={handleNewApiKeySTPN} onNewApiKeyClickCS={handleNewApiKeyCS}/>
    : <p><em>Loading...</em></p>;

    return (
      <div>
        <h1 id="tabelLabel" ><span onClick={() => history.goBack()}>顧客一覧</span> &#12297; {id}</h1>
        <Button onClick={() => history.push(`${location.pathname}/edit`)}>編集</Button>
        <Button onClick={() => history.push(`${location.pathname}/upgrade`)}>アップグレード</Button>
        {contents}
      </div>
    );
}